import { takeEvery } from 'redux-saga/effects'
import { types } from '../actions'

import init from './init'

export function* takes({ dispatch }) {
    yield takeEvery(types.ZOID_INIT, init, { dispatch })
}

const sagas = {
    init,
}

export default sagas
